import React from 'react';
import { Link } from 'react-router-dom';
import { CORES } from '../theme';

/**
 * Cabeçalho padrão das páginas: breadcrumb opcional, título, selo opcional e ações à direita.
 *
 * <PageHeader
 *   titulo="Leads"
 *   trilha={[{ texto: "Leads", para: "/leads" }, { texto: "Editar" }]}
 *   selo={<StatusChip tipo="lead" valor={2} />}
 *   acoes={<Button ...>Novo lead</Button>}
 *   fixo   // gruda no topo ao rolar (formulários longos)
 * />
 */
const PageHeader = ({ titulo, trilha, selo, acoes, fixo = false, children }) => (
    <div
        style={{
            position: fixo ? 'sticky' : 'static',
            top: fixo ? 64 : undefined,
            zIndex: fixo ? 5 : undefined,
            background: fixo ? CORES.fundo : undefined,
            borderBottom: fixo ? `1px solid ${CORES.borda}` : undefined,
            padding: fixo ? '8px 0' : 0,
            marginBottom: 12,
        }}
    >
        {trilha && trilha.length > 0 && (
            <nav aria-label="Você está em" style={{ fontSize: 13, color: CORES.textoSuave, marginBottom: 2 }}>
                {trilha.map((item, i) => (
                    <span key={i}>
                        {i > 0 && ' › '}
                        {item.para ? <Link to={item.para} style={{ color: CORES.textoSuave }}>{item.texto}</Link> : item.texto}
                    </span>
                ))}
            </nav>
        )}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                <h1 style={{ margin: '4px 0' }}>{titulo}</h1>
                {selo}
            </div>
            {acoes && <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>{acoes}</div>}
        </div>
        {children}
    </div>
);

export default PageHeader;
